
import React from 'react';
import deal from './styling/images/dealerships/dealerships.jpg';

const Dealerships = () => {
  
    
  return <div>
    <div>
        <style>
        {`
        .auth_cert {
            display: flex;
            flex-direction: column;
            font-family: 'Arial', sans-serif;
            color: #333;
            margin: 0 8%;
            padding: 20px;
            max-width: 80%;
            border-radius: 8px;
            position: relative;
        }
        .heading {
            font-size: 32px;
            word-spacing: 5px;
            font-weight: bold;
            color: black;
            text-align: center;
            margin-bottom: 5%;
        }
        .auth_img{
            margin-bottom: 5%;
        }
        .row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 5%;
            margin-left: 40px;
            margin-right: 40px;
            flex-wrap: wrap;
            font-size: 18px;
            line-height: 1.6;
}
            .row p{
            margin-bottom:2px;
            margin-top:2px;
            text-align: justify;
          }

           @media (max-width: 768px) {
              .auth_cert {
                  margin: 0 4%;
                  padding: 15px;
                  max-width: 90%;
              }

              .heading {
                  font-size: 24px;
              }

              .row {
                  margin-left: 20px;
                  margin-right: 20px;
                  font-size: 14px;
              }
          }

          /* Responsive for mobile */
          @media (max-width: 480px) {
              .auth_cert {
                  margin: 0 2%;
                  padding: 10px;
                  max-width: 100%;
              }

              .heading {
                  font-size: 20px;
                  margin-bottom: 3%;
              }

              .row {
                  margin-left: 10px;
                  margin-right: 10px;
                  font-size: 12px;
                  text-align: center;
              }

              .auth_img {
                  width: 100%;
                  height: auto;
                  margin-bottom: 10%;
              }

              .row p {
                  margin-bottom: 8px;
              }
          }
            `}
        </style>
    </div>
    <div className='auth_cert'>
      <h1 className='heading'>DEALERSHIPS</h1>
    <img className="auth_img" src={deal} alt="" />
    <div className="row">
    <p>Since 1990, we have built a strong reputation in the market through our decades of trusted service and physical presence. This credibility has led numerous well-known brands to partner with us by granting us their official dealership rights. As a result, we proudly showcase and sell their products, further expanding our offerings and strengthening these valuable partnerships.</p>
      </div>
     <div className="row">
     <p>We are privileged to collaborate with leading international and renowned local brands, all of whom have signed official MoUs with us. These collaborations have proven to be mutually beneficial, as they see growth in both sales and brand recognition while we enhance the diversity of our offerings.</p>
     </div>
    <div className='row'>
    <p>At the heart of our business is a client-centric approach, where our ultimate goal is to provide best and optimum solutions that precisely meet our customers needs. By maintaining transparency, trust, and mutual growth, we ensure long-term success and satisfaction for our clients and brand partners alike.</p>
    </div>
    </div>
  </div>;
};

export default Dealerships;

